// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__3D6hz","title":"style_title__2R3Js","time":"style_time__3GHGn","content":"style_content__3prdY"};